var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { useComponentProps } from '../context/component-props-context';
import { useLang } from '../hooks/use-lang';
var cls = classNames('delete-message');
export var DeleteMessageDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    padding: ", " ", ";\n    font-size: 1.2em;\n    text-align: center;\n  "], ["\n    padding: ", " ", ";\n    font-size: 1.2em;\n    text-align: center;\n  "])), theme.UNIT(4), theme.UNIT(2))
});
// -------- Components -------->
var My = {
  NAME: 'DeleteMessage',
  Container: styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles)
};
export var DeleteMessage = function (props) {
  var _a = useComponentProps(My.NAME, props, DeleteMessageDefaultProps),
    className = _a.className,
    children = _a.children,
    name = _a.name;
  var t = useLang();
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, t('Are you sure you want to delete this '), " ", React.createElement("b", null, name), React.createElement("br", null), React.createElement("br", null), React.createElement("b", null, t('This is not reversible.')), children);
};
DeleteMessage.cls = cls;
var templateObject_1, templateObject_2;